import { useEffect, useMemo, useState } from 'react'
import { Bubble, BubbleHorizontal, NewRegistrationBubble } from './Bubble'
import Styles from './Testimonials.module.scss'
import { shuffledTestimonials, testimonials } from './allTestimonials'
import cx from 'classnames'
import DOMPurify from 'dompurify'

interface Props {
  newFormat?: boolean
  currentPage: string
  inline?: boolean
  noMargin?: boolean
  horizontal?: boolean
  animate?: boolean
}
export const Testimonials = ({ currentPage, inline, newFormat, noMargin, horizontal, animate = true }: Props) => {
  const randomTestimonial = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * shuffledTestimonials.length)
    return shuffledTestimonials[randomIndex]
  }, [])
  const testimonial = newFormat ? randomTestimonial : testimonials[currentPage]
  const [shown, setShown] = useState(false)
  const renderNothing = !testimonial || !shown

  useEffect(() => {
    setShown(false)
    setTimeout(() => setShown(true), animate ? 500 : 0)
  }, [animate])

  if (renderNothing) return null

  if (newFormat) {
    return (
      <div
        className={cx(Styles.newTestimonials, {
          [Styles.newFormat]: newFormat,
          [Styles.noMargin]: noMargin,
        })}
      >
        <div className={cx(Styles.quote, { [Styles.animate]: animate })}>
          {<NewRegistrationBubble />}
          <div
            style={{
              position: 'absolute',
              height: '102px',
              top: '0',
              width: '327px',
              display: 'flex',
              flexWrap: 'wrap',
              alignContent: 'center',
            }}
          >
            <div
              className={Styles.quoteContent}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(testimonial.quote) }}
            ></div>
          </div>
        </div>

        <div className={cx(Styles.profile, { [Styles.animate]: animate })}>
          <div
            data-testid="testimonial-picture-new-format"
            className={cx(Styles.picture, { [Styles.animate]: animate })}
            style={{ backgroundImage: `url(${testimonial.img})` }}
          />
          <div className={cx(Styles.info)}>
            <span className={Styles.name}>{testimonial.name}</span>
            <div className={Styles.positionAndCompany}>
              <span className={Styles.position}>{testimonial.position}</span>
              <span className={Styles.company}>{testimonial.company}</span>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div
        className={cx(Styles.testimonials, {
          [Styles.inline]: inline,
          [Styles.horizontal]: horizontal,
          [Styles.isStartTrialPage]: currentPage === 'blazeStartFreeTrial',
        })}
      >
        <div className={cx(Styles.quote, { [Styles.animate]: animate })}>
          {horizontal ? <BubbleHorizontal /> : <Bubble />}
          <span>{testimonial.quote}</span>
        </div>
        <div
          data-testid="testimonial-picture"
          className={cx(Styles.picture, { [Styles.animate]: animate })}
          style={{ backgroundImage: `url(${testimonial.img})` }}
        />
        <div className={cx(Styles.profile, { [Styles.animate]: animate })}>
          <span className={Styles.name}>{testimonial.name}</span>
          <div className={Styles.positionAndCompany}>
            <span className={Styles.position}>{testimonial.position}</span>
            <span className={Styles.company}>{testimonial.company}</span>
          </div>
        </div>
      </div>
    )
  }
}
